import styled from 'styled-components'

export const MusicHallFormStyled = styled.div`

`
